import {
    categoryGroupZodSchema,
    type CategoryGroup,
} from "@@/shared/categories/category-groups";
import { iconNameZodString } from "@@/shared/icon-name";
import { asArray } from "@@/utilities/as-array";
import type { Except } from "type-fest";
import { z } from "zod";
import { isoAndUnixZodSchema, nowIsoAndUnix } from "../date-time/iso-and-unix";
import { entityStateZodSchema } from "../entity-status";
import { translatableZodSchema } from "../translations/translation";
import {
    categoryIdFactory,
    categoryIdZodSchema,
    type CategoryId,
} from "./category-id";
const categoryZodObject = z.object({
    _id: categoryIdZodSchema,
    _type: z.literal("CATEGORY"),
    _createdAt: isoAndUnixZodSchema,
    _status: entityStateZodSchema,
    title: translatableZodSchema,
    groups: z.array(categoryGroupZodSchema).min(1),
    subtitle: translatableZodSchema.optional(),
    tags: z.string().array(),
    iconName: iconNameZodString.optional(),
});

type Category = z.infer<typeof categoryZodObject>;

type FactoryParams = Except<
    Category,
    "_id" | "_createdAt" | "_type" | "_status"
> & {
    _id?: CategoryId;
    _status?: Category["_status"];
};
const categoryFactory = (input: FactoryParams): Category => {
    return {
        ...input,
        _id: input._id ?? categoryIdFactory(),
        _type: "CATEGORY",
        _createdAt: nowIsoAndUnix(),
        _status: input._status ?? "ACTIVE",
    };
};

const isCategory = (input: unknown): input is Category => {
    return (input as Category)?._type === "CATEGORY";
};

const defaultNewCategoryParams = (
    groups: CategoryGroup | CategoryGroup[],
): FactoryParams => {
    return {
        title: "",
        tags: [],
        iconName: "fa-question",
        groups: asArray(groups),
    };
};

export {
    categoryFactory,
    categoryZodObject,
    defaultNewCategoryParams,
    isCategory,
};
export type { Category };
